import axios from "axios";

export default {
  async all(params) {
    let result = await axios.get(
      `/api/v1/metrics`,
      {
        params: params
      }
    );
    return result.data.data;
  }
}
